import { render, staticRenderFns } from "./templateProductModelDetail.vue?vue&type=template&id=22437430&scoped=true"
import script from "./templateProductModelDetail.vue?vue&type=script&lang=js"
export * from "./templateProductModelDetail.vue?vue&type=script&lang=js"
import style0 from "./templateProductModelDetail.vue?vue&type=style&index=0&id=22437430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22437430",
  null
  
)

export default component.exports